import { render, staticRenderFns } from "./About.vue?vue&type=template&id=228d7325&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QFab,QFabAction,QDialog,QSelect,QItem,QItemSection,QFile,QIcon,QCardActions,QStepper,QStep,QForm,QStepperNavigation,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QFab,QFabAction,QDialog,QSelect,QItem,QItemSection,QFile,QIcon,QCardActions,QStepper,QStep,QForm,QStepperNavigation})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
